import styled from 'styled-components';

export const AnalyticsV3Container = styled.div`
  width: 100%;
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  background-color: #eef0f6;
  column-gap: 18px;
  padding: 18px;
`;

export const LeftContainer = styled.div`
  width: 216px;
`;
export const RightContainer = styled.div`
  width: calc(100% - 216px);
`;
